module.exports = __webpack_public_path__ + "img/icon_changespeed_gray.5c9c4cf0.svg";